import FiverrLogo from '@fiverr-private/icons/logos/fiverr_logomaker_logo';
import { INTEGRATIONS } from '../../../../constants';
import WordpressLogoDesktop from '../../LogoMakerLogo/Integrations/Wordpress/DesktopLogo';
import WordpressLogoMobile from '../../LogoMakerLogo/Integrations/Wordpress/MobileLogo';
import W3schoolsLogoDesktop from '../../LogoMakerLogo/Integrations/W3schools/DesktopLogo';
import W3schoolsLogoMobile from '../../LogoMakerLogo/Integrations/W3schools/MobileLogo';
import AdaloLogoDesktop from '../../LogoMakerLogo/Integrations/Adalo/DesktopLogo';
import AdaloLogoMobile from '../../LogoMakerLogo/Integrations/Adalo/MobileLogo';
import ElementorLogoDesktop from '../../LogoMakerLogo/Integrations/Elementor/DesktopLogo';
import ElementorLogoMobile from '../../LogoMakerLogo/Integrations/Elementor/MobileLogo';
import WooLogo from '../../LogoMakerLogo/Integrations/Woo';

export const PORTAL_NAME = 'logo-maker-header-content';

export const LIGHT_COLOR = '#FFFFFF';
export const DARK_COLOR = '#404145';

export const DESKTOP_LOGO_MAP = {
    [INTEGRATIONS.NONE]: FiverrLogo,
    [INTEGRATIONS.WORDPRESS]: WordpressLogoDesktop,
    [INTEGRATIONS.W3SCHOOLS]: W3schoolsLogoDesktop,
    [INTEGRATIONS.ADALO]: AdaloLogoDesktop,
    [INTEGRATIONS.ELEMENTOR]: ElementorLogoDesktop,
    [INTEGRATIONS.WOO]: WooLogo,
};

export const MOBILE_LOGO_MAP = {
    [INTEGRATIONS.NONE]: FiverrLogo,
    [INTEGRATIONS.WORDPRESS]: WordpressLogoMobile,
    [INTEGRATIONS.W3SCHOOLS]: W3schoolsLogoMobile,
    [INTEGRATIONS.ADALO]: AdaloLogoMobile,
    [INTEGRATIONS.ELEMENTOR]: ElementorLogoMobile,
    [INTEGRATIONS.WOO]: WooLogo,
};

export const DESKTOP_LOGO_WIDTH: Record<string, number> = {
    [INTEGRATIONS.NONE]: 183,
    [INTEGRATIONS.WORDPRESS]: 382,
    [INTEGRATIONS.W3SCHOOLS]: 392,
    [INTEGRATIONS.ADALO]: 295,
    [INTEGRATIONS.ELEMENTOR]: 374,
    [INTEGRATIONS.WOO]: 265,
};

export const MOBILE_LOGO_WIDTH: Record<string, number> = {
    [INTEGRATIONS.NONE]: 131,
    [INTEGRATIONS.WORDPRESS]: 177,
    [INTEGRATIONS.W3SCHOOLS]: 176,
    [INTEGRATIONS.ADALO]: 170,
    [INTEGRATIONS.ELEMENTOR]: 173,
    [INTEGRATIONS.WOO]: 188,
};

export const LINKS = {
    HOME: {
        bigQuery: 'home',
        mixpanel: 'Home ',
    },
    TESTIMONIALS: {
        bigQuery: 'testimonials',
        mixpanel: 'Testimonials',
    },
    TUTORIALS: {
        bigQuery: 'tutorials',
        mixpanel: 'Tutorials',
    },
    PRICING: {
        bigQuery: 'pricing',
        mixpanel: 'pricing',
    },
    GO_TO_FIVERR: {
        bigQuery: 'go_to_fiverr',
        mixpanel: 'Go To Fiverr',
    },
    SAVED_LOGOS: {
        bigQuery: 'saved_logos',
        mixpanel: 'Saved Logos',
    },
    NEW_LOGO: {
        bigQuery: 'new_logo',
        mixpanel: 'New Logo',
    },
    MY_DESIGNS: {
        bigQuery: 'saved_logos.designs',
        mixpanel: 'My Designs',
    },
    MY_FAVOURITES: {
        bigQuery: 'saved_logos.favourites',
        mixpanel: 'My Favourites',
    },
    MANAGE_LOGOS: {
        bigQuery: 'manage_logos',
        mixpanel: 'Manage Logos',
    },
    HELP: {
        bigQuery: 'help',
        mixpanel: 'Help',
    },
};

export const BIGQUERY_SIGN_IN_EVENT = {
    type: 'clicked_header.sign_in.button_click_header',
    group: 'header_clicks',
};

export const BIGQUERY_SIGN_UP_EVENT = {
    type: 'clicked_header.registration.button_click_header',
    group: 'header_clicks',
};

export const MIXPANEL_SIGN_IN_EVENT = {
    eventName: 'Clicked sign in',
    eventData: { 'Source Component': 'Header' },
};
